var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-My_Orders_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_Orders_",
    "data-name": "My Orders_",
    clipPath: "url(#clip-My_Orders_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9011",
    "data-name": "Group 9011",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_254",
    "data-name": "Ellipse 254",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#add2f0",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7905",
    "data-name": "Group 7905",
    transform: "translate(10.003 8.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M410.376,288.388h9.475l2.411,4.641v12.648H407.929V293.029Z",
    transform: "translate(-407.145 -287.876)",
    fill: "#0071cd",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M48.912,5.046,48.9,5.022a.863.863,0,0,0-.065-.112L46.29.513A1.031,1.031,0,0,0,45.4,0H36.646a1.031,1.031,0,0,0-.891.515L33.17,5a.537.537,0,0,0-.052.126.906.906,0,0,0-.056.315V17.023a1.261,1.261,0,0,0,1.26,1.26h13.4a1.261,1.261,0,0,0,1.26-1.26V5.4c0-.016,0-.031,0-.046A.533.533,0,0,0,48.912,5.046ZM41.577,1.072h3.8l2,3.459h-5.8Zm-4.906,0h3.834V4.531H34.677ZM47.912,17.023a.189.189,0,0,1-.188.188h-13.4a.189.189,0,0,1-.188-.188V5.6H47.912Z",
    transform: "translate(-33.062 0)",
    fill: "#0071cd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917",
    transform: "translate(4.365 8.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M191.485,265.851a.75.75,0,0,0-1.06,0l-3.347,3.347-1.287-1.287a.749.749,0,1,0-1.06,1.06l1.817,1.817a.749.749,0,0,0,1.06,0l3.877-3.877A.75.75,0,0,0,191.485,265.851Z",
    transform: "translate(-184.512 -265.632)",
    fill: "#0071cd"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyOrders);
export default __webpack_public_path__ + "static/media/My Orders.521af91c05551394ca9daf26dea6ed8e.svg";
export { ForwardRef as ReactComponent };